<template>
  <div>
  <v-toolbar
    color=""
    fixed
    dark
    app
    flat
    class="dd-dark top-tool-bar"
    >
    <v-icon  @click.stop="handleDrawerToggle">
      menu
    </v-icon>
    <v-toolbar-title class="ml-0 pl-3">

    </v-toolbar-title>
      <v-text-field
        flat                
        prepend-icon="search"
        label="Search"
        class="hidden-sm-and-down "
        style="margin-top: 7px;"
        v-model="searchTerm"        
      >
      </v-text-field>
      <v-spacer></v-spacer>
      <v-menu offset-y origin="center center" class="elelvation-1" :nudge-bottom="14" transition="scale-transition">
        <v-btn icon flat slot="activator" @click="toggleNotificationDialog()">
        <v-badge color="red" overlap>
          <span v-if="unseenNotifications"  slot="badge">{{unseenNotifications}}</span>
          <v-icon large>notifications</v-icon>
        </v-badge>
        </v-btn>
      </v-menu>
      <v-menu offset-y origin="center center" :nudge-bottom="10" transition="scale-transition">
        <v-btn icon large flat slot="activator">
          <dd-avatar :user="currentUser"></dd-avatar>
        </v-btn>
        <v-list class="pa-0">
          <template v-for="(item,index) in items">
            <v-list-tile :key="index" 
                         v-if="item.active" 
                         :to="!item.href ? { name: item.name } : null" 
                         :href="item.href" 
                         @click="item.clickEvent(item)" 
                         ripple="ripple" 
                         :disabled="item.disabled" 
                         :target="item.target" 
                         rel="noopener">          
              <v-list-tile-action v-if="item.icon">              
                <v-tooltip left>
                  <template #activator="data">    
                      <v-icon slot="activator">{{ item.icon }}</v-icon>
                  </template>
                  <span>{{item.title}}</span>
                </v-tooltip>
              </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-list>
      </v-menu>    
    </v-toolbar>
      <v-dialog max-width="500px" v-model="items[1].showDialog">
        <v-card>
          <v-card-title>
            <label>{{currentUser.email}} van omgeving veranderen</label>
            <v-spacer></v-spacer>            
            <i class="fas fa-times" @click="items[1].showDialog=false"></i>              
          </v-card-title>
          <v-card-text>                    
            <switch-tenacy :tenants="currentUser.availableTenants" :user="currentUser"></switch-tenacy>
          </v-card-text>
        </v-card>
      </v-dialog>     

      <v-dialog max-width="500px" scrollable v-model="showNotificationDialog" v-if="showNotificationDialog">
        <v-card>
          <v-card-title><h3>Uw berichten</h3></v-card-title>
          <v-divider></v-divider>
           <v-list three-line>
            <template v-for="(item,index) in globalNotifications" >              
              <v-list-tile
                
                :key="item.key"
                avatar
                
              >
                <v-list-tile-avatar color="white" >
                  <img :src="item.from_avatar">
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title ><strong>{{item.subject}}</strong></v-list-tile-title>
                  <v-list-tile-sub-title ></v-list-tile-sub-title>
                  <v-list-tile-sub-title ><span class='text--primary'>{{item.from}} </span> &mdash; {{item.message}}</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>                  
                  <v-list-tile-action-text><span class="orange--text" v-if="!item.seen"><strong>Nieuw</strong><br></span>{{item.timestamp | timeAgoTwitter}} </v-list-tile-action-text>
                  
                  
                </v-list-tile-action>

              </v-list-tile>
              <v-divider></v-divider>
            </template>
          </v-list>
          <v-flex class="text-xs-center pb-2">
            <v-pagination
              v-model="notificationPage"
              :length="totalNotifcationPages"
              :total-visible="5"
              @input="seen()"
            ></v-pagination>
          </v-flex>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn flat v-if="hasNotifications" @click="clearNotifications()">Lijst wissen</v-btn>              
          </v-card-actions>
          <!-- <v-card-title>
            <h4>Notificaties</h4>
            <v-spacer></v-spacer>            
            <i class="fas fa-times" @click="showNotificationDialog=false"></i>              
          </v-card-title>
          <v-card-text>    
      
            <div style="padding:8px; margin:2px;" :class="`toast-notification-container toast-type-${note.type} `" v-for="(note,index) in globalNotifications" :key="index">
              <v-flex>
                <v-layout row align-center>
                    <v-spacer></v-spacer>
                    <div style="margin-right:8px;" class="toast-notification-timestamp">
                        {{note.timestamp}}                      
                    </div>                                                                          
                    <i class="fas fa-times" style="cursor:pointer;" @click="removeNote(note)"></i>
                </v-layout>
              </v-flex>               
              <v-layout row align-center>
                <v-flex style="padding:4px; text-align:center;" xs2 >
                  <i style="font-size:32px;" :class="`fas ${setIcon(note.type)}`"></i>
                </v-flex>
                <v-flex xs10  style="padding:4px;" justify-start  >                     
                    <v-flex xs12 class="toast-notification-title">{{note.from}}</v-flex>
                    <v-flex xs12 class="toast-notification-body">{{note.message}}</v-flex>                
                </v-flex>
              </v-layout>
            </div>
            <v-layout row wrap>
              <v-spacer></v-spacer>                
              <v-btn v-if="hasNotifications" @click="clearNotifications()">Lijst wissen</v-btn>              
              <v-btn v-if="hasNotifications" @click="dumpNotification()">Console</v-btn>              
            </v-layout>
          </v-card-text> -->
        </v-card>
      </v-dialog>        
  </div>
</template>
<script>

import { mapGetters } from 'vuex'
import router from '../../router'
import DdAvatar from "../../components/global/DdAvatar"   
import SwitchTenacy from "./SwitchTenancy"
import { unauthenticated } from "../../plugins/core/dd.data.connect"
import * as types from '../../store/types'
export default {
  name: 'app-toolbar',
  components: {
    DdAvatar,
    SwitchTenacy
  },
  data: () => ({    
    showNotificationDialog:false,
    notificationPage: 1,
    notificationsPerPage: 5,
    
    dialogActive:true,
    items: [
      {
        active:true,
        icon: 'account_circle',
        href: '/my-profile',
        title: 'Mijn Profiel',
        clickEvent: (vm) => {}
      },   
      {
        showDialog:false,
        active:false,
        icon: 'far fa-window-restore',
        href: '#',
        title: 'Wisselen van omgeving',
        clickEvent: (item) => {      
          item.showDialog = true;
        }
      },               
      {
        active:true,
        icon: 'fas fa-sign-out-alt',
        href: '#',
        title: 'Uitloggen',
        clickEvent: (vm) => {
            unauthenticated()
        } 
      },    
               
    ],
    searchTerm: '',
  }),
  watch:{
    searchTerm(nv){
      this.$store.dispatch(types.GLOBAL_SEARCH_TERM, nv)
    }
  },
  computed:{
    ...mapGetters({
      _globalNotifications: types.GLOBAL_NOTIFICATIONS,
      mainMenuShown: types.MAIN_MENU_SHOWN,
      currentUser: types.CURRENT_USER
    }),
    hasNotifications(){
      return this.globalNotifications.length > 0 ? true : false
    },
    toolbarColor () {
      return this.$vuetify.options.extra.mainNav;
    },
    totalNotifcationPages(){
      if(this._globalNotifications){
        return Math.ceil(this._globalNotifications.length / this.notificationsPerPage)
      }
      else{
        return 1
      }
      
    },
    globalNotifications(){
      let start = (this.notificationPage - 1) * this.notificationsPerPage;
      return this._globalNotifications.slice(start, (start + this.notificationsPerPage))
    },
    unseenNotifications(){
      if(this._globalNotifications){
        return this._globalNotifications.filter(ele => !ele.seen).length
      }
      return null
    }
  },
  methods: {
    toggleNotificationDialog(){
      console.log(this._globalNotifications)
      if(this.hasNotifications){        
        this.showNotificationDialog=!this.showNotificationDialog
        this.seen()
      }
    },
    seen(){
      let vm = this
        setTimeout(() => {
          for(let ele of this.globalNotifications){
              if(!ele.seen){
                
                vm.$store.dispatch(types.NOTIFICATION_SEEN, ele.key)
                
              }
                
          }          
        }, 1500)
    },
    removeNote(note){
      this.$store.dispatch(types.REMOVE_GLOBAL_NOTIFICATIONS, note );
    },
    clearNotifications(){
      this.$store.dispatch(types.CLEAR_GLOBAL_NOTIFICATIONS, [] );
      this.showNotificationDialog=false;
    },
    handleDrawerToggle () {
      this.$store.dispatch(types.MAIN_MENU_SHOWN, {show:!this.mainMenuShown.show} );
    },
    handleFullScreen () {
      // Util.toggleFullScreen();
    },
    setIcon(type){
        if(type == "notification")
          return "fa-bell"

        if(type == "system")
          return "fa-desktop"

        if(type == "user_message")
          return "fa-user"

        return "alert-circle"          
    },
    dumpNotification(){
      console.log(this._globalNotifications)
    }    
  }, 
  mounted(){
     if(this.currentUser && this.currentUser.availableTenants && this.currentUser.availableTenants.length > 1){
        // set environment switch to true if user has more then one tenant
        this.items[1].active = true;
     }      
  },
};
</script>
<style>
  .top-tool-bar{
    z-index: 3 !important;
  }
  .toast-notification-container{
    padding:8px;
  
  }

</style>
